<script>
   /**************************************************************/
   /* Svelte component for LoadingsPlot settings                 */
   /**************************************************************/

   import Container from '../controls/Container.svelte';
   import Select from '../controls/Select.svelte';
   import Range from '../controls/Range.svelte';
   import PlotTypeSelector from '../controls/PlotTypeSelector.svelte';

   export let params;
   export let model;

   let comp1 = 1;
   let comp2 = model && model.ncomp > 1 ? 2 : 1;
   let plotType = 'p';
   let showLabels = 'hide';
   let axesScale = 'normal';


   $: params = {
      comp: [comp1, comp2],
      plotType,
      showLabels,
      axesScale,
   }
</script>

{#if model  }
<Container label="">
   <p class="title">Loadings plot</p>
</Container>
<PlotTypeSelector bind:value={plotType} plotTypeOptions={['p', 'l', 'h']} />

<Container label='PC (y-axis):'>
   <Range id='comp2' bind:value={comp2} min={1} max={model.ncomp} step={1} decNum={0} discrete={true} />
</Container>
{#if plotType === 'p'}
<Container label='PC (x-axis):'>
   <Range id='comp1' bind:value={comp1} min={1} max={model.ncomp} step={1} decNum={0} discrete={true} />
</Container>
{/if}
<Container label='Labels:'>
   <Select id='showLabels' bind:value={showLabels} options={['hide', 'show']} />
</Container>
<Container label='Axes:'>
   <Select id='axesScale' bind:value={axesScale} options={['normal', 'equal']} />
</Container>
{/if}

